import React from 'react';
import { ForceGraph, ForceGraphNode, ForceGraphLink } from 'react-vis-force';

export function NetworkChart(props) {
    const { data } = props;
    const { groupNetwork } = data;
    const { nodes } = groupNetwork;

    const formattedNodes = nodes
        ?.filter(node => node.name !== 'N/A')
        .map(node => ({
            id: node._id,
            name: node.name,
            contracts: node.contracts,
            radius: node.points + 10,
            type: node.type,
        }));

    const formattedNodeLinks = groupNetwork?.nodeLinks
        .filter(GraphNodeLink => {
            return formattedNodes.findIndex(node => node.id === GraphNodeLink.target) !== -1;
        })
        .map(GraphNodeLink => {
            return { source: GraphNodeLink.source, target: GraphNodeLink.target };
        });

    return formattedNodes === undefined ? null : (
        <ForceGraph
            simulationOptions={{
                width: 700,
                height: 500,
                alpha: 1.1,
                radiusMargin: 30,
            }}
        >
            {formattedNodes.map(formattedNode => {
                return (
                    <ForceGraphNode
                        key={Math.random()}
                        node={formattedNode}
                        showLabel
                        fill={formattedNode.type === 'company' ? '#80d6e9e8' : '#62ab62ec'}
                        r={formattedNode.points}
                    />
                );
            })}
            {formattedNodeLinks.map(GraphNodeLink => {
                return (
                    <ForceGraphLink
                        key={Math.random()}
                        link={GraphNodeLink}
                        fill="green"
                        strokeWidth={200}
                    />
                );
            })}
        </ForceGraph>
    );
}
